import { STATE_LIST } from "@vahak/core/dist/constants";
import { SelectOption } from "@vahak/core-ui/dist/components/Select";
import { compareString } from "@vahak/core-ui/dist/methods";

import { generateSelectOption } from "../../../../../methods/uiUtil";

export const MARKETPLACE_STATE_OPTIONS: SelectOption<number>[] = [...STATE_LIST]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((state) => generateSelectOption(state.name, state.id, state.id));

export function findMarketplaceStateOptionFromUrlParam(param?: string) {
    if (!param?.trim()) {
        return undefined;
    }

    return MARKETPLACE_STATE_OPTIONS.find((state) => compareString(state.label, param.trim()));
}

export const MARKETPLACE_ANY_DESTINATION_ID = -1;

export const MARKETPLACE_ANY_DESTINATION_OPTION = generateSelectOption(
    "Any Destination",
    MARKETPLACE_ANY_DESTINATION_ID,
    MARKETPLACE_ANY_DESTINATION_ID
);

export const MARKETPLACE_DESTINATION_STATE_OPTIONS: SelectOption<number>[] = [
    MARKETPLACE_ANY_DESTINATION_OPTION,
    ...MARKETPLACE_STATE_OPTIONS
];

/** @deprecated Use MARKETPLACE_STATE_OPTIONS */
export const STATE_LIST_OPTION = MARKETPLACE_STATE_OPTIONS;

/** @deprecated Use MARKETPLACE_DESTINATION_STATE_OPTIONS */
export const STATE_LIST_OPTION_WITH_ANY_DESTINATION = MARKETPLACE_DESTINATION_STATE_OPTIONS;

/** @deprecated Use MARKETPLACE_ANY_DESTINATION_ID */
export const ANY_DESTINATION_ID = MARKETPLACE_ANY_DESTINATION_ID;

export function isAnyDestinationSelected(value?: SelectOption<number>[]) {
    return !value?.length || value.every((item) => item.id === MARKETPLACE_ANY_DESTINATION_ID);
}

export function resolveMultiDestinationChange(
    _previous: SelectOption<number>[] | undefined,
    selected: SelectOption<number>[]
) {
    const pickedAny = selected.some((item) => item.id === MARKETPLACE_ANY_DESTINATION_ID);

    if (pickedAny) {
        return [];
    }

    return selected.filter((item) => item.id !== MARKETPLACE_ANY_DESTINATION_ID);
}

export function getMultiSelectDisplayLabel(value: SelectOption<number>[] | undefined) {
    const selectedStates = (value ?? []).filter((item) => item.id !== MARKETPLACE_ANY_DESTINATION_ID);

    if (!selectedStates.length) {
        return "";
    }

    return selectedStates.map((item) => item.label).join(", ");
}
